//Models
PJQ.models.preferences = {};

PJQ.models.preferences.Preferences = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'preferences'
			}
		])
	},
	afterInit: function () {
		if (this.get('preferences') == null)
			this.set('preferences', {});
	},
	getPref: function (key) {
		return this.get('preferences')[key];
	},
	hasPref: function (key) {
		return typeof this.get('preferences')[key] !== 'undefined';
	},
	setPref: function (key, value) {
		this.get('preferences')[key] = value;
	},
	deletePref: function (key) {
		delete this.get('preferences')[key];
	}
});

PJQ.constants.preferenceTypes = {
	ACTION_ITEM_WORK_COMPLETED_STATUS_OVERRIDE: "actionItemWorkCompletedStatusOverride",
	ADD_PARTICIPANTS_BID_PACKAGE_RADIUS: "projectScopeRadius",
	ADDRESS_BOOK_DEFAULT_DISPLAY_DIRECTORY: "addressBookDefaultDisplayDirectory",
	ADDRESS_BOOK_COLOR_COLUMNS: "addressBookColorColumns",
	ADDRESS_BOOK_CONTACT_COMPANY_ID_LABEL: "addressBookContactCompanyIdLabel",
	ADDRESS_BOOK_CONTACT_ID_LABEL: "addressBookContactIdLabel",
	ADDRESS_BOOK_SHOW_PREQUAL_URL: "addressBookShowPrequalURL",
	ADDRESS_BOOK_SHOW_PREQUAL_EDITOR: "addressBookShowPrequalEditor",
	ADDRESS_BOOK_HIDE_DEFAULT_SEARCH: "addressBookHideDefaultSearch",
	ADDRESS_BOOK_HIDE_MINORITY_STATUS: "addressBookHideMinorityStatus",
	ADDRESS_BOOK_HIDE_SECTOR: "addressBookHideSector",
	ADDRESS_BOOK_APPROVAL_REQUIRED: "addressBookSelfAddApprovalRequired",
	ADDRESS_BOOK_CONTACT_UPDATER_ENABLED: "addressBookContactUpdaterEnabled",
	ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP: "addressBookEnableAdminRequiredFields",
	ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_CORE: "addressBookEnableAdminRequiredFieldsCore",
	ADDRESS_BOOK_HIDE_INACTIVE_CONTACTS: "addressBookHideInactiveContacts",
	ADDRESS_BOOK_DEFAULT_COUNTRY: "addressBookDefaultCountry",
	ADDRESS_BOOK_DEFAULT_FILTERS: "addressBookDefaultFilters",
	ADDRESS_BOOK_DEFAULT_LOCATION_FILTERS: "addressBookDefaultLocationFilters",
	ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE: "addressBookPreventDefaultUserType",
	ALLOW_SUB_GROUP_EDIT: "addressBookAllowSubGroupEdit",
	PJQ_REGISTRATION_WORKAREAS_OPTIONAL: "pjqRegistrationWorkAreasOptional",
	ALLOW_SUB_GROUP_EDIT_REQUIRED: "addressBookAllowSubGroupEditRequired",
	APP_NAV_ITEMS: "appNavItems",
	ASAP_SCHEDULE_CONTRAINT_ENABLED: "asapScheduleConstraintEnabled",
	BIDDING_PROJECTS_REQUIRE_APPROVAL: "biddingProjectsRequireApproval",
	BIDDING_PROJECTS_TAB_NAME: "biddingProjectsTabName",
	DISABLE_BIDDING_PROJECTS: "disableBiddingProjects",
	BIDDING_PROJECTS_INCLUDE_COLUMNS: "biddingProjectsIncludeColumns",
	BID_FORM_NOT_SUBMITTED_STATUS_NAME_OVERRIDE: "bidFormNotSubmittedStatusNameOverride",
	PORTAL_APP_NAV_ITEMS: "portalAppNavItems",
	CAN_EDIT_MINORITY_CLASS_SUB: "rsvpEditMinorityClassification",
	CAN_EDIT_UNION_STATUS_SUB: "rsvpEditUnionStatus",
	CAN_ORDER_ON_ACCOUNT: "canOrderOnAccount",
	COPY_SCOPES_GRID_LAYOUT: "copyProjectScopesGridLayout",
	DAILY_REPORT_ATTACHMENTS_NAME: "dailyReportAttachmentsName",
	DAILY_REPORT_SURVEY_NAME: "dailyReportSurveyName",
	DAILY_REPORT_NAV_ORDER: "dailyReportNavOrder",
	DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT: "isLockReportAfterSubmit",
	DAILY_REPORT_NEW_WORK_LOG_REPORT: "dailyReportNewWorkLogReport",
	DRAWING_SHARE_PREVENT_EXPIRATION: "drawingSharePreventExpiration",
	DRAWING_HIDE_TITLE: "drawingsHideTitle",
	DRAWING_HIDE_TAG: "drawingsHideTag",
	DEFAULT_AUTO_SELECT_DISABLED: "defaultAutoSelectDisabled",
	DIRECTORY_REPORT_REMOVE_FROM_PROJECT: "directoryReportRemoveFromProject",
	DISABLE_BLUE_BOOK_PUBLISH: "isBlueBookPublishDisabled",
	DISABLE_DAILY_REPORTS: "isDailyReportsDisabled",
	DISABLE_DAILY_REPORT_EXPENSES: "isDisableDailyReportExpenses",
	DISABLE_PREQUAL: "disablePrequal",
	DISABLE_PROJECT_PRIVATE_ATTACHMENTS: "disableProjectPrivateAttachments",
	DISABLE_PROJECT_PRIVATE_MESSAGES: "projectWallHidePrivateMessages",
	DISABLE_PROJECT_CONTACTS: "disableProjectContacts",
	DISABLE_PROJECT_DOCUMENTS: "disableProjectDocuments",
	DISABLE_PROJECT_PHOTOS: "disableProjectPhotos",
	DISABLE_RFI: "isRFIDisabled",
	DISABLE_SIMPLE_SEARCH: "disableSimpleSearch",
	DOCUMENTS_TAB_ID: "appDocumentsTabId",
	DRAWINGS_CURRENT_SET_DEFAULT_OFF: "drawingsCurrentSetDefaultOff",
	DOWNLOAD_CONTACT_UPDATE_REQ: "rsvpContactInfoRequired",
	DOWNLOAD_RESPONSE_REQ: "preventDownloadUntilResponse",
	DOWNLOAD_TERMS_PROJECT_CF: "rsvpDownloadTermsProjectCustomField",
	DOWNLOAD_TERMS_PROJECT: "rsvpDownloadTermsProject",
	DOWNLOAD_TERMS_SIGNATURE_REQ: "rsvpDownloadTermsSignatureRequired",
	DOWNLOAD_TERMS: "rsvpDownloadTerms",
	EMAIL_LOGO_URL: "emailLogoURL",
	ENABLE_AB_PREQUAL_EDIT: "enableAbPrequalEdit",
	ENABLE_ADMIN_PAID_DOWNLOADS: "enableAdminPaidDownloads",
	ENABLE_BID_FILER: "isBidFilerEnabled",
	ENABLE_BID_FORMS: "isBidFormsEnabled",
	ENABLE_BID_FORM_SEALING: "enableBidFormSealing",
	ENABLE_BID_PACKAGES: "enableBidPackages",
	ENABLE_BID_PACKAGES_COUNT: "enableBidPackagesCount",
	ENABLE_CONTACT_FIELD_SETTINGS: "enableContactFieldSettings",
	ENABLE_USER_FIELD_SETTINGS: "enableUserFieldSettings",
	ENABLE_COPY_PROJECT: "enableCopyProject",
	ENABLE_DATA_TABLE_FIXED_HEADER: "enableDataTableFixedHeader",
	ENABLE_DELIVER_BY_LOCAL: "enableDeliverByLocal",
	ENABLE_DELIVER_BY_PICKUP: "enableDeliverByPickup",
	ENABLE_DIRECTORY: "isDirectoryEnabled",
	ENABLE_DIRECTORY_EDIT: "isAllowDirectoryEdit",
	DISABLE_DRAWINGS: "isDrawingsDisabled",
	ENABLE_DRAWING_ANNOTATIONS: "isDrawingAnnotationsEnabled",
	ENABLE_DRAWING_ANNOTATION_REFS: "enableDrawingAnnotationRefs",
	ENABLE_FAX: "enableFax",
	ENABLE_FIELD_REPORTS: "fieldReportEnabled",
	ENABLE_GANTT_COLUMN_SORTING: "enableGanttColumnSorting",
	ENABLE_INVOICES: "enableInvoices",
	ENABLE_MEETINGS: "enableMeetings",
	ENABLE_MEETING_TRANSCRIPTIONS: 'enableMeetingTranscriptions',
	DISABLE_OLD_SUBMITTALS: "disableOldSubmittals",
	DISABLE_OLD_ADDRESSBOOK: "disableOldAddressBook",
	ENABLE_NEW_ADDRESSBOOK: "enableNewAddressBook",
	ENABLE_OLD_ADDRESSBOOK: "enableOldAddressBook",
	ENABLE_FINANCES: "enableFinances",
	ENABLE_NEW_FILES: "isNewFilesEnabled",
	ENABLE_NEW_FILE_VIEWER: "enableNewFileViewer",
	ENABLE_NEW_GANTT: "enableNewGantt",
	ENABLE_PERMISSIONS: "enablePermissions",
	ENABLE_PERMISSIONS_PORTAL: "enablePermissionsPortal",
	ENABLE_PREQUAL_AUDITLOG: "enablePrequalAuditLog",
	ENABLE_PREQUAL_COMMENTS: "enablePrequalComments",
	ENABLE_PROJECT_CONTAINERS: "projectContainerEnabled",
	ENABLE_PROJECT_LOCATIONS: "enableProjectLocations",
	ENABLE_PROJECT_MESSAGE_DECLINE_QUESTION: "enableProjectMessageDeclineQuestion",
	ENABLE_PROJECT_NDA_DECLINE: "enableProjectNDADecline",
	ENABLE_NEW_PROJECT_CONTACTS_MANAGEMENT: "enableNewProjectContactsManagement",
	ENABLE_NEW_PROJECT_HISTORY: "enableNewProjectHistory",
	ENABLE_NEW_PROJECT_WALL: "enableNewProjectWall",
	ENABLE_NEW_SUBMITTALS: "enableNewSubmittals",
	ENABLE_NEW_UPLOAD_BID_DOCS: "enableNewUploadBidDocs",
	ENABLE_RAW_FILE_UPLOAD_BILLING: "enableRawFileUploadBilling",
	ENABLE_RESOURCE_ALLOCATION: "enableResourceAllocation",
	ENABLE_SCREENINGS: "screeningEnabled",
	ENABLE_TIME_CARDS: "enableTimeCards",
	ENABLE_TIMECARDS_SIGNATURE: "enableTimeCardsSignature",
	ENABLE_USER_GROUPS: "enableUserGroups",
	ENABLE_WORK_LOG_OVERTIME: "enableWorkLogOvertime",
	FILE_UPLOADER_SIDE_BY_SIDE: "fileUploaderSideBySide",
	EXPAND_PROJECT_ROOT_SHARED_FOLDERS: "expandProjectRootSharedFolders",
	DISABLE_PREQUAL_ATTACHMENT_DELETE: "disablePrequalAttachmentDelete",
	DISABLE_PREQUAL_CONTACT_ATTACHMENT_LINK: "disablePrequalContactAttachmentLink",
	DISABLE_PROJECT_ATTACHMENTS: "isProjAttDisabled",
	DISABLE_PROJECT_WALL_MESSAGING_OLD: "disableOldProjectWallProjectMessaging",
	ENABLE_NEW_CONTACT_IMPORT: "enableNewContactImport",
	DISABLE_NEW_ADDRESSBOOK: "isNewAddressBookDisabled",
	DISABLE_NEW_DOCUMENTS: "isNewDocumentsDisabled",
	ENABLE_NEW_RAW_FILE_UPLOAD: "enableNewRawFileUpload",
	DISABLE_NEW_SETTINGS: "isNewSettingsDisabled",
	DISABLE_SHARE_PEI: "disableSharePEI",
	DISABLE_WORK_AREAS: "disableWorkAreas",
	ENABLE_ACTION_ITEMS: "enableActionItems",
	ENABLE_ERP_ADMIN: "enableERPAdmin",
	ENABLE_PREQUAL_PRIVATE_GROUPS: "enablePrequalPrivateGroups",
	ENABLE_SUB_RESPONSE: "projectMessagingAllowIndecisiveSubs",
	ENABLE_PROJECT_NAME_PAGE_TITLE: "enableProjectNamePageTitle",
	ENABLE_PRINT_ON_DEMAND: "enablePrintOnDemand",
	ENABLE_PUNCH_LISTS: "isPunchListsEnabled",
	ENABLE_REGIONS_MAP: "enableRegionsMap",
	ENABLE_RFI_NEW: "isRFINewEnabled",
	ENABLE_RFI: "isRFIEnabled",
	DISABLE_SCHEDULING: "isSchedulingDisabled",
	ENABLE_SCHEDULING: "isSchedulingEnabled",
	ENABLE_SCHEDULE_TASK_NOTIFICATION_SETTINGS: "enableScheduleTaskNotificationSettings",
	ENABLE_REPORTS_NEW: "enableNewReports",
	ENABLE_OLD_CALENDAR: "enableOldCalendar",
	ENABLE_PROJECT_STATUS_ID: "enableNewProjectStatusId",
	ENABLE_SCOPES: "enableProjectScope",
	ENABLE_SUBMITTALS: "submittalEnabled",
	ENABLE_SUBMITTAL_WORKFLOW: "enableSubmittalWorkflow",
	ENABLE_TOP_OF_PAGE_BUTTON: "isEnableTopOfPageButton",
	ENABLE_WORK_AREAS_ZIP_RADIUS_COUNTY_PICKER: "enableWorkAreasZipRadiusCountyPicker",
	ENABLE_WORK_AREAS: "enableWorkAreas",
	EXPAND_PROJECT_ATTACHMENTS: "expandProjectAttachments",
	FILE_NAVIGATOR_VIEW_ON_CLICK: "fileNavigatorViewOnClick",
	FLATTEN_DL_ALL_PROJECT_ATTACHMENTS: "flattenDLAllProjAtt",
	GROUP_LABEL: "addressBookGroupLabel",
	GROUP_LEVELS: "addressBookGroupLevels",
	HAS_GROUPS_LINKED: "hasGroupsLinked",
	HIDE_DAILY_REPORT_UNSUBMIT: "hideDailyReportUnsubmit",
	HIDE_SAVE_PAYMENT_INFO: "hideSavePaymentInfo",
	HIDE_VERSION_SELECTOR_ISSUED_ON: "hideDrawingVersionSelectorIssuedOn",
	HIDE_SUBMITTAL_ITEM_TYPE: "hideSubmittalItemType",
	IS_DISABLE_PARENT_GROUPS: "isDisableParentGroups",
	IS_DOCUMENT_CLERK: "isDocumentClerk",
	IS_DOCUMENT_CLERK_COMPANY: "isDocumentClerkCompany",
	IS_DODGE_CRM: "dodgeCRMPortal",
	IS_DODGE_WG: "dodgeWhiteGlovePortal",
	IS_ENABLE_NEW_DOWNLOADS: "isEnableNewDownloads",
	IS_HIDE_UNION_STATUS: "addressBookHideUnionStatus",
	IS_PROJECT_HOME_READONLY: "isProjectHomeReadonly",
	IS_PROJECT_WALL_MESSAGING_NEW: "enableNewProjectWallProjectMessaging",
	IS_PROJECT_WALL_MESSAGING_NEW_PORTAL: "portalEnableNewProjectWallProjectMessaging",
	IS_PROQUAL_CUSTOMER: "isProqualCustomer",
	IS_PROQUAL_PORTAL: "proQualPortal",
	IS_REQUIRE_BIDFORM_ATTACHMENT: "isRequireBidformAttachment",
	ITB_RESUME_LABEL: "itbResumeLabel",
	ITB_SEND_NEW_LABEL: "itbSendNewLabel",
	IS_SSO_ENABLED: "isSSOEnabled",
	ITB_TAB_LABEL: "itbTabLabel",
	MESSAGE_RESPONSE_DUE_LABEL: "messageResponseDueLabel",
	MESSAGE_STATUS_LIST: "messageStatusList",
	NEW_APP_PORTAL: 'portalNewApp',
	NO_REQUIRE_UNION_SUB: 'addressBookUnionStatusNotRequired',
	ORDER_DELIVER_BY: 'orderDeliverBy',
	ORDER_LARGE_FORMAT_BINDING_TYPE: 'orderLargeFormatBindingType',
	ORDER_LARGE_FORMAT_PAPER_TYPE: 'orderLargeFormatPaperType',
	ORDER_LARGE_FORMAT_PRINT_SIZE: 'orderLargeFormatPrintSize',
	ORDER_LARGE_FORMAT_QUANTITY: 'orderLargeFormatQuantity',
	ORDER_PO_REQUIRED: 'orderPORequired',
	ORDER_SMALL_FORMAT_BINDING_TYPE: 'orderSmallFormatBindingType',
	ORDER_SMALL_FORMAT_PAPER_TYPE: 'orderSmallFormatPaperType',
	ORDER_SMALL_FORMAT_QUANTITY: 'orderSmallFormatQuantity',
	PLAN_EXPRESS_PORTAL: "planExpressPortal",
	PREQUAL_HEADER: "prequalHeader",
	PREQUAL_ALLOW_SIGNATURE_ALWAYS: "prequalAllowSignatureAlways",
	PREQUAL_HELP_CONTACT_DETAILS: "prequalHelpContactDetails",
	PREQUAL_PROJECT_REFERENCE_COUNT: "prequalProjectReferenceCount",
	PREQUAL_PROJECT_REFS_GC_COL_NAME: "prequalProjectRefsGcColName",
	PREQUAL_SIGN_AND_SAVE: "prequalSignAndSave",
	PREQUAL_SIGNATURE_ALERT: "prequalSignatureAlert",
	PREQUAL_TAX_ID_MASK: "prequalTaxIdMask",
	PREQUAL_TERMS: "prequalTerms",
	PREVAILING_WAGE_LABEL: "prevailingWageLabel",
	PREVENT_NATIONWIDE_WORK_AREAS: "preventNationwideWorkAreas",
	PREVENT_NATIONWIDE_WORK_AREAS_PORTAL: "portalPreventNationwideWorkAreas",
	PREVENT_NATIONWIDE_WORK_AREAS_SUB: "portalPreventNationwideWorkAreas_Sub",
	PRIVATE_MESSAGING_USER_ID_DEFAULT: "internalMessageUserIdDefault",
	PROCORE_ACCESS_REFRESH_TOKEN: "proCoreAccessRefreshToken",
	PROCORE_CLIENT_ID: "proCoreClientId",
	PROCORE_CLIENT_REDIRECT: "proCoreClientRedirect",
	PROCORE_PROJECT_NUMBER_CUSTOM_FIELD: "procoreProjectNumberCustomFieldId",
	PROCORE_URL_API: "proCoreURL",
	PROCORE_URL_AUTH: "proCoreAuthURL",
	PROJ_DASHBOARD_SELECT_ALL_ATTACHMENTS: "rsvpSelectAllDocuments",
	PROJECT_ACTIVITY_RANK_STATUS_LIST: "projectActivityRankStatusList",
	PROJECT_DEFAULT_BID_DUE_TIME: "projectDefaultBidDueTime",
	PROJECT_DEFAULT_BID_DUE_TIME_AMPM: "projectDefaultBidDueTimeAMPM",
	PROJECT_DETAILS_EXPORT: "projectDetailsExport",
	PROJECT_MANAGEMENT_CONTACTS_ENABLE_PRIMARY: 'projectManagementContactsEnablePrimary',
	PROJECT_MESSAGING_DEFAULT_TEMPLATE: "projectMessagingDefaultTemplateKey",
	PROJECT_MESSAGING_DISABLE_QUICKADD: "projectMessagingDisableQuickAdd",
	PROJECT_MESSAGING_DISABLE_RESPONSE_DUE: "projectMessagingDisableResponseDue",
	PROJECT_MESSAGING_DISTANCE_ICON_THRESHOLD: "projectMessagingDistanceIconThreshold",
	PROJECT_MESSAGING_ENABLE_REPLYTO_OVERRIDE: "projectMessagingEnableReplyToOverride",
	PROJECT_MESSAGING_MAX_GROUP_DISPLAY: "projectMessagingMaxGroupDisplay",
	PROJECT_MESSAGING_SEND_OPTIONS_EMAIL_ALWAYS: "sendEmail",
	PROJECT_MESSAGING_SEND_OPTIONS_FAX_ALWAYS: "sendFax",
	PROJECT_MESSAGING_SEND_OPTIONS_FAX_EMAIL_FAILED: "sendFaxIfEmailFailed",
	PROJECT_MESSAGING_SEND_OPTIONS_FAX_NO_EMAIL: "sendFaxOnlyIfNoEmail",
	PROJECT_MESSAGING_RESTRICT_TO_EXISTING_GROUPS: "projectMessagingRestrictToExistingGroups",
	PROJECT_NAV_HEADER_CUSTOM_MARKUP: "projectNavHeaderCustomMarkup",
	PROJECT_NDA_CHECKED_DEFAULT: "projectNDACheckedDefault",
	PROJECT_NDA_MODAL_TITLE: "projectNDAModalTitle",
	PROJECT_NOTES_LABEL: "projectNotesLabel",
	PROJECT_SHARED_FOLDER_NAME_OVERRIDE: "projectSharedFolderNameOverride",
	PROJECT_STATUS_LIST: "projectStatusList",
	PROJECT_STATUS_NON_DEFAULT_REQUIRED: "projectStatusNonDefaultRequired",
	PROJECT_USER_1_LABEL: "projectUser1Label",
	PROJECT_USER_2_HIDE: "projectUser2Hide",
	PROJECT_USER_2_LABEL: "projectUser2Label",
	PROJECT_WALL_ADMIN_BID_DUE_DATE_REQUIRED: "projectWallAdminBidDueDateRequired",
	PROJECT_WALL_ADMIN_NOTES_HIDDEN: "projectWallAdminNotesHidden",
	PROJECT_WALL_ADMIN_NOTES_REQUIRED: "projectWallAdminNotesRequired",
	PROJECT_WALL_ADMIN_USER_2_REQUIRED: "projectWallAdminUser2Required",
	PROJECT_WALL_ADMIN_VIEW_BID_PACKAGES: "enableProjectWallViewBidPackages",
	PROJECT_WALL_ADMIN_VIEW_COMPANY: "enableProjectWallViewCompany",
	PROJECT_WALL_ADMIN_VIEW_CONTACT: "enableProjectWallViewContact",
	PROJECT_WALL_ADMIN_VIEW_GROUP_COMPANY: "enableProjectWallViewGroupCompany",
	PROJECT_WALL_ADMIN_VIEW_GROUP_CONTACT: "enableProjectWallViewGroupContact",
	PROJECT_WALL_ADMIN_ZIP_REQUIRED: "projectWallAdminPostalCodeRequired",
	PROJECT_WALL_MESSAGING_SHOW_TEMPLATES: "projectWallMessagingShowTemplates",
	PROJECT_WALL_RSVP_AUTO_REPORT: "rsvpAutoReportTab",
	PROJECT_WALL_DEFAULT_MODULE: "projectWallDefaultModule",
	PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS: "projectDefaultPrivateRootFolderTemplate",
	PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS: "projectDefaultPublicRootFolderTemplate",
	PROJECT_WALL_MESSAGING_TAB_NAME: "projectWallMessagingTabName",
	PROJECT_WALL_PRIMARY_PROJECT_MANAGER_REQUIRED: "projectWallPrimaryProjectManagerRequired",
	PROJECT_WALL_SORT_GROUPS_BY_RESPONSE: "projectWallAdminSortGroupsByResponse",
	PROJECT_WALL_HIDE_BIDS_DUE: "projectWallHideBidsDue",
	PROJECT_WALL_TAB_ID: "projectWallTabId",
	PROJECT_SCHEDULE_FILTER_USER_ID: "projectScheduleFilterUserId",
	PUBLIC_PROJECTS_REQ_REG: "publicProjectsRequireRegistration",
	PUBLIC_PROJECTS_EMPTY_MESSAGE: "publicProjectsEmptyMessage",
	PUNCH_LIST_WORK_COMPLETED_STATUS_OVERRIDE: "punchListWorkCompletedStatusOverride",
	QUIKBID_GROUP_IDS: "quikBidGroupIds",
	QUIKBID_ZIP_CODES: "quikBidZipCodes",
	REGISTRATION_REDIRECT: "registrationRedirect",
	REGISTRATION_TAB_ID: "registrationTabId",
	RESOURCE_ALLOCATION_PRIMARY_ONLY: "resourceAllocationPrimaryOnly",
	RESPONSE_DUE_LABEL: "responseDueLabel",
	PROJECT_START_LABEL: "projectStartLabel",
	PROJECT_FINISH_LABEL: "projectFinishLabel",
	REQUIRE_PROJECT_START_FINISH: "requireProjectStartFinish",
	RESTRICT_GROUP_COUNT: "addressBookGroupsRestrictChoiceCount",
	RESOURCE_ALLOCATION_PROJECT_CUSTOM_FIELD_COLOR_BAR: "resourceAllocationProjectCustomFieldColorBar",
	RFI_DEFAULT_PUBLIC: "rfiDefaultPublic",
	RFI_DEFAULT_NOTIFY_PROJECT_CONTACTS: "rfiDefaultNotifyProjectContacts",
	RFI_DEFAULT_NOTIFY_PARTICIPANTS: "rfiDefaultNotifyParticipants",
	RFI_LOCATION_LABEL: "rfiLocationLabel",
	RFI_NAME_OVERRIDE: "rfiNameOverride",
	RFI_RESPONSE_NAME_OVERRIDE: "rfiResponseNameOverride",
	RSVP_DISABLE_PER_GROUP: "rsvpDisablePerGroup",
	RSVP_FOLDER_CHECKBOXES_ONLY: "rsvpFolderCheckboxesOnly",
	SETTINGS_LOCK: "settingsLock",
	PROJECT_DETAILS_PROJECT_ID: "projectDetailsProjectId",
	PROJECT_GANTT_HEADER_CUSTOM_MARKUP: "projectGanttHeaderCustomMarkup",
	HIDE_RESOURCE_CENTER: "hideResourceCenter",
	SIMPLE_SEARCH_DEFAULT_ADDRESS_BOOK: "simpleSearchDefaultAddressBook",
	SIMPLE_SEARCH_DEFAULT_RADIUS: "simpleSearchDefaultRadius",
	SORT_USER_ATTACHMENTS: "sortUserAttachments",
	SORT_COMPANY_ATTACHMENTS: "sortCompanyAttachments",
	SQUARE_TAKEOFF_ENABLED: "enableSquareTakeoff",
	STACK_TAKEOFF_ENABLED: "enableStackTakeoff",
	START_END_HIDE: "startEndHide",
	SUB_ADDRESS_REQUIRED: "rsvpAddressRequired",
	SUB_RESTRICT_SINGLE_EMAIL: "addressBookForceSingleEmail",
	SUB_ZIP_REQUIRED: "rsvpPostalCodeRequired",
	TIMECARD_WEEKLY_EXPORT_TEMPLATE: "timeCardWeeklyExportTemplate",
	ENABLE_WORK_LOG_WORK_ITEMS: 'enableWorkLogWorkItems',
	ENABLE_WORK_LOG_PROGRESS: 'enableWorkLogProgress',
	WORK_LOG_WORK_ITEM_LABEL: 'workLogWorkItemLabel',
	WORK_LOG_WORK_ITEM_SUB_TEXT: 'workLogWorkItemSubText',
};
